import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  image?: string;
  keywords?: string[];
  type?: 'website' | 'article';
}

const SEO: React.FC<SEOProps> = ({
  title = 'Udobong Ntia (Udy Ntia) | Oil & Gas Executive | Energy Leader',
  description = 'Udobong Ntia (also known as Udy Ntia) is a purpose-driven leader dedicated to empowering future generations and driving sustainable economic growth in the energy sector.',
  canonicalUrl = 'https://udobongntia.com',
  image = 'https://udobongntia.com/logo192.png',
  keywords = ['Udobong Ntia', 'Udy Ntia', 'Oil and Gas Executive', 'Energy Leader', 'ExxonMobil'],
  type = 'website',
}) => {
  const defaultTitle = 'Udobong Ntia (Udy Ntia) | Oil & Gas Executive | Energy Leader';
  
  const fullTitle = title === defaultTitle ? title : `${title} | Udobong Ntia (Udy Ntia)`;

  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
